import { moduleProviderFactory } from "core/providers";
import { PivotList } from "application/pivot/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.pivot",
				pattern: "/pivot",
				children: [
					{
						name: "master.app.main.pivot.list",
						pattern: "",
						tabTitle:"Patient Count Report",
						component: PivotList,
						//authorization: "${sectionName}.read",
						data: {
							title: "PIVOT.LIST.TITLE",
						},
					},
				],
			},
		],
		menu : [
            {
                title: 'MENU.REPORTS',
                order: 9,
				icon: "table-view",
				authorization: "reportSection.read",
                subMenu: [
                    {
                        title: "MENU.PATIENT_COUNT_REPORT",
						authorization: "pivotGridSection.read",
						route: "master.app.main.pivot.list",
						order: 3,
                    }                    
                ]
            }
        ]
	});
})();
